import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export default function ExpandableSummary({ bullets }) {
  const [expanded, setExpanded] = useState(false)

  if (!bullets || bullets.length === 0) return null

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className="text-[13px] md:text-xs text-cyan-400 active:text-cyan-300 md:hover:text-cyan-300 flex items-center gap-1.5 transition-colors touch-target"
      >
        <ChevronDown className={`w-3.5 h-3.5 md:w-3 md:h-3 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`} />
        {expanded ? 'Hide' : 'TL;DR'}
      </button>
      {expanded && (
        <ul className="mt-2 space-y-1.5 md:space-y-1 pl-4">
          {bullets.map((bullet, i) => (
            <li key={i} className="text-[13px] md:text-xs text-gray-400 list-disc leading-relaxed">
              {bullet}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
